import  { FC, useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n, { i18nError } from '../../i18n.js';

// Pages
import Home from '../../pages/Home/Home.js';
import ForgotUsername from '../../pages/ForgotUsername/ForgotUsername.js';
import PrivacyPolicy from "../../pages/PrivacyPolicy/PrivacyPolicy.tsx";
import SplashPage from "../../pages/SplashPage/SplashPage.tsx";
import { LanguageProvider } from '../LanguageContext.js';
import React from 'react';
import Auth0ProviderWithHistory from '../../auth/authProvider.js';

// Utils

// Hooks
// import Analytics from '../../components/analytics/analytics.js';
interface MyProps {}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [pathname]);

  return null;
};

const Main: FC<MyProps> = () => {
  const content = useTranslation('plan-results-content');
  const errorContent = useTranslation('error-messages');

  useEffect(() => {
    i18n.changeLanguage();
  }, []);

  // if (i18nError) {
  //   return <Error />;
  // }

  return (
    <div>
      <main data-testid="Main">
        <Auth0ProviderWithHistory>
      <LanguageProvider>
        <Router>
          <ScrollToTop/>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/splash" element={<SplashPage/>}/>
            <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
            <Route path="/forgotusername" element={<ForgotUsername />} />
            <Route path="/dashboard" element={<Home />} />
          </Routes>
        </Router>
        </LanguageProvider>
        </Auth0ProviderWithHistory>
      </main>
    </div>
  );
};

export default Main;
